import {ActionList, Checkbox, FormControl} from '@primer/react'
import {useMergeControlActions, useMergeControlInputs, useMergeControlState} from './merge-control-context'
import styles from './BypassToggle.module.css'

type BypassToggleProps = {
  className?: string
}

export function BypassToggle({className}: BypassToggleProps) {
  const {isAdminBypassToggleChecked, showBypassToggle} = useMergeControlState()
  const onToggleAdminBypass = useMergeControlActions()

  if (!showBypassToggle) return null

  return (
    <div className={className}>
      <FormControl>
        <Checkbox onChange={onToggleAdminBypass} checked={isAdminBypassToggleChecked} />
        <FormControl.Label>
          <span className="fgColor-danger"> Merge without waiting for requirements to be met (bypass rules) </span>
        </FormControl.Label>
      </FormControl>
    </div>
  )
}

export function BypassToggleMenuItem() {
  const {isAdminBypassToggleChecked, mergeControlModel, showBypassToggle} = useMergeControlState()
  const onToggleAdminBypass = useMergeControlActions()
  const {setShouldFocusPrimaryMergeButton} = useMergeControlInputs()

  if (!showBypassToggle) return null

  return (
    <ActionList.Group selectionVariant="multiple" aria-label="Optional override" className={styles.BypassGroup}>
      <ActionList.Item
        variant="danger"
        selected={isAdminBypassToggleChecked}
        onSelect={() => {
          onToggleAdminBypass()
          // Changing bypass can replace the queue control or its inactive tooltip, removing the menu anchor.
          setShouldFocusPrimaryMergeButton(true)
        }}
      >
        Bypass requirements
        <ActionList.Description variant="block">
          {mergeControlModel.type === 'merge-queue'
            ? 'Skip the queue and merge directly.'
            : 'Use the selected merge method without waiting.'}
        </ActionList.Description>
      </ActionList.Item>
    </ActionList.Group>
  )
}
